export default __webpack_public_path__ + "static/media/signal.cfd3583c.svg";